import { defineMessages } from 'react-intl';

const trns = defineMessages({
  catalogLabel: {
    id: 'FCddpq',
    defaultMessage: 'Каталог ліків'
  },
  useFullAdvices: {
    id: '5UwNYZ',
    defaultMessage: 'Корисні поради'
  },
  myMedicine: {
    id: 'oSib7G',
    defaultMessage: 'Моя аптечка'
  },
  aboutUs: {
    id: 'nrKlyL',
    defaultMessage: 'Про нас'
  },
  help: {
    id: 'OUNj6I',
    defaultMessage: 'Допомога'
  },
  viewAllCategories: {
    id: 'h0CBcP',
    defaultMessage: 'Всі категорії'
  },
  viewCategory: {
    id: '76+ten',
    defaultMessage: 'Всі категорії {selectedCategory}'
  },
  viewCatalog: {
    id: 'h0CBcP',
    defaultMessage: 'Всі категорії'
  }
});

export default trns;
